import { cva } from 'class-variance-authority';

export const alertVariants = cva(
  `
    relative flex flex-row items-center gap-3.5 overflow-clip rounded-xl p-4
    [&>svg]:absolute [&>svg]:top-4 [&>svg]:left-4 [&>svg]:size-4
    [&>svg]:shrink-0
    [&>svg+div]:translate-y-0
    [&>svg~div]:translate-y-[-3px] [&>svg~div]:pl-6
  `,
  {
    variants: {
      variant: {
        default: [
          'bg-semantic-blue-50',
          'border border-semantic-blue-700',
          'text-semantic-blue-900',
          '[&>svg]:text-semantic-blue-700',
        ].join(' '),
        destructive: [
          'bg-semantic-red-50',
          'border border-semantic-red-700',
          'text-semantic-red-700',
          '[&>svg]:text-semantic-red-700',
        ].join(' '),
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);
